/* eslint-disable */
import api from '../_api';

export const outreachService = {
  getItems(args) {
    return api.get('/outreach/', {
      params: args,
    });
  },
  getItem(id) {
    return api.get(`/outreach/${id}/`);
  },
  getStats(id, customerId) {
    return api.get(`/outreach/${id}/stats/`, {
      params: { customer_id: customerId, with_appointments: true },
    });
  },
  getCustomerOutReachContacts(args) {
    return api.get('/customeroutreach/', {
      params: args,
    });
  },
  createLinkOutreach(args) {
    return api.post('/customeroutreach/', args);
  },
};
